import React, { useContext, useEffect, useState } from 'react';
import { Button, Input, Loader, Modal, Table } from '@itds/elements/index.js';
import { CarrierContext } from '../../../contexts/CarrierContext';
import Notification from '@carrier/components/Notification';

import EditFeatureDrawer from './Edit';

import { Api } from '@carrier/utils/Api';

const List = () => {
  const [product_features, setProductFeatures] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [feature, setFeature] = useState(null);
  const { notification, setNotification } = useContext(CarrierContext);
  const [modal, setModal] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState(null);

  useEffect(() => {
    const params = {};

    setLoading(true);

    if (search.length) {
      params.name = search;
    }

    Api.loadProductFeatures(params).then(response => {
      setProductFeatures(response.data);
      setLoading(false);
    });
  }, [search]);

  const loadProductFeatures = action => {
    const params = {};

    setLoading(true);

    if (search.length) {
      params.name = search;
    }

    Api.loadProductFeatures(params)
      .then(response => {
        setProductFeatures(response.data);
        setLoading(false);
        if (action === 'save') {
          setNotification({
            message: 'Successfully Saved Product Feature',
            type: 'success'
          });
        } else if (action === 'delete') {
          setNotification({
            message: 'Successfully Deleted Product Feature',
            type: 'success'
          });
        }
      })
      .catch(() => {
        setTimeout(() => {
          if (action === 'save') {
            setNotification({
              message: 'Unable to save product feature at this time',
              type: 'error'
            });
          } else if (action === 'delete') {
            setNotification({
              message: 'Unable to delete product feature at this time',
              type: 'error'
            });
          }
        }, 2000);
      });
  };

  const handleSearch = e => {
    if (e.keyCode === 13) {
      setSearch(e.target.value);
    }
  };

  const handleSave = () => {
    setFeature(null);
    loadProductFeatures('save');
  };

  const handleDelete = (obj, e) => {
    e.stopPropagation();

    window.scrollTo(0, 0);
    setModal(true);
    setDeleteInfo(obj);
  };

  const confirmDelete = () => {
    window.scrollTo(0, 0);

    Api.deleteProductFeature(deleteInfo.id)
      .then(() => {
        loadProductFeatures('delete');
        setModal(null);
        setDeleteInfo(null);
      })
      .catch(() => {
        setModal(null);
        setDeleteInfo(null);
      });
  };

  return loading ? (
    <Loader />
  ) : (
    <>
      <Notification {...notification} />
      <EditFeatureDrawer
        feature={feature}
        onClose={setFeature.bind(null, null)}
        onSave={handleSave}
        show={!!feature}
      />

      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 40 }}>
        <Input onKeyDown={handleSearch} placeholder='Search for a feature' style={{ width: 300 }} />

        <Button onClick={setFeature.bind(null, { id: null, name: '' })}>Add Feature</Button>
      </div>

      <Table
        columns={[
          {
            id: 'name',
            is_sortable: true,
            label: 'Name'
          },
          {
            id: 'product_ids',
            is_sortable: true,
            label: '# of Products',
            render: feature => feature.product_ids.length,
            styles: { textAlign: 'center' }
          },
          {
            id: 'actions',
            render: feature => {
              return (
                <Button
                  color='RED'
                  inline={true}
                  onClick={handleDelete.bind(null, feature)}
                  small={true}
                >
                  Delete
                </Button>
              );
            },
            styles: { textAlign: 'right' }
          }
        ]}
        data={product_features}
        defaultSortColumn={{ id: 'name' }}
        onRowClick={setFeature}
      />
      {modal ? (
        <Modal
          buttons={[
            {
              color: 'RED',
              children: 'Confirm Delete',
              onClick: confirmDelete,
              style: { marginLeft: 'auto' }
            }
          ]}
          contained={true}
          onClose={() => {
            setModal(null);
          }}
          title={`Delete "${deleteInfo.name}"`}
        >
          <div style={{ padding: 40, fontSize: 16, textAlign: 'center', lineHeight: '1.5em' }}>
            Are you sure you want to delete "{deleteInfo.name}"?
          </div>
        </Modal>
      ) : null}
    </>
  );
};

export default List;
